import moment from 'moment';
import { EMARPOLDocuments, TMARPOLTank } from '../../marpol/@types';
import {
    ECRBRecordCode,
    ECRBRecordState,
    TCRBCommonData,
    TCRBCommonFields,
    ESubstanceCategories,
} from '../@types';

export type TCRBItem12 = {
    tanks: TCRBItem12Tank[];
};

export type TCRBItem12Tank = {
    selectedTank: TMARPOLTank;
    transferQuantity: number;
    newQuantity: number;
    substance: string;
    catgeory: ESubstanceCategories;
};

export type TCRBItem12P1 = {
    totalQuantityDischarged: number;
};

export type TCRBItem13 = {
    noOfCleaningMachinesPerTank: number;
    durationOfWashingCycles: number;
    washType: 'Hot' | 'Cold';
};

export type TCRBItem14 = {
    receiptNumber: string;
    receiptAttachment: string;
    portName: string;
    receptionFacilityName: string;
};

export type TCRBD1 = TCRBCommonFields &
    TCRBCommonData & {
        id: string;
        recordCode: ECRBRecordCode.CRBD;
        item12: TCRBItem12;
        item12P1: TCRBItem12P1;
        item13: TCRBItem13;
        item14: TCRBItem14;
    };

export type TCRBD = TCRBD1;

const CRBD_DEFAULTS: {
    D: TCRBD1;
} = {
    D: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.CRB,
        state: ECRBRecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item12: {
            tanks: [],
        },
        item12P1: {
            totalQuantityDischarged: 0,
        },
        item13: {
            noOfCleaningMachinesPerTank: 0,
            durationOfWashingCycles: 0,
            washType: 'Hot',
        },
        item14: {
            receiptNumber: '',
            receiptAttachment: '',
            portName: '',
            receptionFacilityName: '',
        },
        recordCode: ECRBRecordCode.CRBD,
    },
};

export { CRBD_DEFAULTS };
